import { useState, useEffect } from "react";

const withDisableAutofill = WrappedComponent => props => {
    
    const [isReadOnly, setIsReadOnly] = useState(true);

    const handleOnBlur = () => {
        if(isReadOnly === false) {
            setIsReadOnly(true);
        }
    }

    const handleOnFocus = () => {
        if(isReadOnly){
            setIsReadOnly(false);
        }
    }

    useEffect(() => {
        setIsReadOnly(true);
    },[]);

    const updatedProps = {...props, readOnly :isReadOnly, onBlur: () => handleOnBlur(), onFocus : () => handleOnFocus()}
    return <WrappedComponent {...updatedProps}/>
};

export default withDisableAutofill;